import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Footer } from 'src/app/interfaces/footer';
import { FooterService } from 'src/app/services/footer.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  footer?: Footer[]
  menus = [
    {
      title: 'Home',
      url: '/',
      hasKids: false,
      children: []
    },
    {
      title: 'About Us',
      url: '/about-us',
      hasKids: true,
      children: [
        {
          title: 'Overview',
          url: '/overview'
        },
        {
          title: 'Management Team',
          url: '/management-team'
        }
      ]
    },
    {
      title: 'Services',
      url: '/services',
      hasKids: true,
      children: [
        {
          title: 'Mail Room Management',
          url: '/service/s2-mail-room-management'
        },
        {
          title: 'Express Delivery and Courier Services',
          url: '/service/s1-express-delivery-courier-services'
        },
        {
          title: 'Cargo Clearing & amp; Forwarding',
          url: '/service/s3-cargo-clearing-forwarding'
        },
        {
          title: 'Bulk Mail Deliveries',
          url: '/service/s4-bulk-mail-deliveries'
        },
        {
          title: 'Haulage',
          url: '/service/s5-haulage'
        }
      ]
    },
    {
      title: 'Contact Us',
      url: '/contact-us',
      hasKids: false,
      children: []
    },
    {
      title: 'Get Quote',
      url: '/get-quote',
      hasKids: false,
      children: []
    }
  ]

  constructor(private footerService: FooterService, private router: Router) { }

  ngOnInit(): void {
    this.fetchFooter()
  }

  fetchFooter(): void {
    this.footerService.getFooter().snapshotChanges().pipe(
      map(changes => changes.map(c => ({
        id: c.payload.doc.id, ...c.payload.doc.data()
      })
      ))
    ).subscribe(data => {
      this.footer = data
    })
  }

}
